import React from 'react';
import { theme } from '../styles/MyFoodTheme';

const { mediaBreakpoints } = theme;

export const useScreen = () => {
  const [currentWidth, setCurrentWidth] = React.useState(window.innerWidth);
  const [isMobile, setIsMobile] = React.useState(false);
  const [isTablet, setIsTablet] = React.useState(false);
  const [isDesktop, setIsDesktop] = React.useState(false);

  React.useEffect(() => {
    setCurrentWidth(window.innerWidth);

    const checkScreenSize = () => {
      setCurrentWidth(window.innerWidth);

      if (currentWidth <= mediaBreakpoints.small) {
        setIsMobile(true);
        setIsTablet(false);
        setIsDesktop(false);
        return;
      }

      if (
        currentWidth > mediaBreakpoints.small &&
        currentWidth < mediaBreakpoints.medium
      ) {
        setIsMobile(false);
        setIsTablet(true);
        setIsDesktop(false);
        return;
      }

      setIsMobile(false);
      setIsTablet(false);
      setIsDesktop(true);
    };

    window.addEventListener('resize', checkScreenSize);
    checkScreenSize();

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, [currentWidth]);

  return { isMobile, isTablet, isDesktop };
};

export default useScreen;
